export default ( { className } ) => (
    /**
     * Ícone de seta ">"
     * com preenchimento na azul
     * 
     */
     <svg
     className={className}
     width="7"
     height="9"
     viewBox="0 0 7 9"
     fill="none"
     xmlns="http://www.w3.org/2000/svg"
   >
     <path
       d="M6.0715 4.25532C6.34803 4.45489 6.34803 4.86664 6.0715 5.06621L1.4259 8.41888C1.09522 8.65753 0.633301 8.42124 0.633301 8.01344L0.633301 1.30809C0.633301 0.90029 1.09522 0.664002 1.4259 0.902651L6.0715 4.25532Z"
       fill="#3C71DD"
       fillOpacity="0.87"
     />
   </svg>
  );